<template>

    <Head title="Countries"/>

    <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Countries</h1>

    <SettingsTabs/>

    <div class="bg-white py-6 px-4 sm:p-6 shadow">
        <div class="flex justify-end">
            <search-filter :show-filter="false" v-model:value="form.search" class="w-1/4 max-w-md mr-4"
                           @reset="reset"></search-filter>
            <Button v-on:click="toggleCreateCountrySlideOut"
                    class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2">
                <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                Add New Country
            </Button>
        </div>
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Name
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-center text-gray-500 uppercase tracking-wider">
                                    Code
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-center text-gray-500 uppercase tracking-wider">
                                    Alt Code
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-center text-gray-500 uppercase tracking-wider">
                                    Regions
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-center text-gray-500 uppercase tracking-wider">
                                    VAT Rates
                                </th>
                                <th scope="col" class="relative px-6 py-3">
                                    <span class="sr-only">Edit</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="countries.data.length > 0" v-for="(country, index) in countries.data" :key="index"
                                :class="{'bg-gray-100': index % 2}" class="hover:bg-gray-50 cursor-pointer">
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                    @click="editCountrySlideout(country)">
                                    {{ country.name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-500">
                                    {{ country.code }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-500">
                                    {{ country.alt_code }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-500">
                                    <div class="w-full flex justify-center items-center gap-3">

                                        <span class="underline text-pitch-purple" @click="editRegions(country)">{{
                                                Object.keys(country.regions).length
                                            }}</span>
                                        <button @click="editRegions(country)" type="button"
                                                class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <PlusSmIconSolid class="h-4 w-4 text-white" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-center">
                                    <div class="w-full flex justify-center items-center gap-3">
                                        <span class="underline text-pitch-purple text-gray-500 "
                                              @click="editVATRates(country)">{{
                                                Object.keys(country.vat_rates).length
                                            }}</span>
                                        <button @click="editVATRates(country)" type="button"
                                                class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <PlusSmIconSolid class="h-4 w-4 text-white" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </td>
                                <td class="px-6  py-4 whitespace-nowrap text-right text-sm">
                                    <span class="text-red-600 hover:text-red-900 float-right"
                                          @click="deleteCountry(country)">
                                        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                        </svg>
                                    </span>
                                </td>
                            </tr>
                            <tr v-else>
                                <td colspan="6" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 bg-gray-100">
                                    There are no countries available for your search criteria.
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination :links="countries.links"/>
        </div>
    </div>
    <CreateCountry ref="createCountrySlideOut"/>
    <CreateRegions ref="createRegionsSlideOut"/>
    <CreateVATRates ref="createVATRatesSlideOut"/>
</template>


<script>

import {Head} from "@inertiajs/vue3";
import SettingsTabs from "@/Components/SettingsTabs.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import CreateCountry from "@/Components/SlideOuts/CreateCountry";

import Pagination from "@/Components/Pagination.vue";
import SearchFilter from "@/Components/SearchFilter.vue";
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import CreateRegions from "@/Components/SlideOuts/CreateRegions";
import CreateVATRates from "@/Components/SlideOuts/CreateVATRates";
import {PlusSmIcon as PlusSmIconSolid} from '@heroicons/vue/solid'
import Button from "@/Components/Button.vue";

export default {
    layout: Authenticated,
    components: {
        CreateVATRates,
        CreateRegions,
        Pagination,
        SettingsTabs,
        Head,
        CreateCountry,
        SearchFilter,
        PlusSmIconSolid,
        Button
    },
    props: {
        countries: Object
    },
    data() {
        return {
            form: {
                search: null
            }
        }
    },
    methods: {
        toggleCreateCountrySlideOut() {
            this.$refs.createCountrySlideOut.updating = false;
            this.$refs.createCountrySlideOut.open();
        },
        editCountrySlideout(country) {
            this.$refs.createCountrySlideOut.updating = true;
            this.$refs.createCountrySlideOut.form.id = country.id;
            this.$refs.createCountrySlideOut.form.name = country.name;
            this.$refs.createCountrySlideOut.form.code = country.code;
            this.$refs.createCountrySlideOut.form.alt_code = country.alt_code;
            this.$refs.createCountrySlideOut.open();
        },
        deleteCountry(id) {
            this.$swal.fire({
                title: 'Remove Country',
                html: "You are removing a country. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        // Delete the country
                        Inertia.delete(route('admin.settings.countries.country.delete', id), {
                            preserveScroll: true
                        });
                    }
                });
        },
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        editVATRates(country) {
            this.$refs.createVATRatesSlideOut.country = country;
            this.$refs.createVATRatesSlideOut.vat_rates = country.vat_rates;
            this.$refs.createVATRatesSlideOut.open();
        },
        editRegions(country) {
            this.$refs.createRegionsSlideOut.country = country;
            this.$refs.createRegionsSlideOut.regions = country.regions;
            this.$refs.createRegionsSlideOut.open();
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('admin.settings.countries.index'), pickBy(this.form), {preserveState: true})
            }, 500),
        },
    },

}
</script>
